export const __API_PREFIX = '/tinymdm/console-partner';
export const __API_VERSION = 'v1';
export const __API_SERVER_URL = import.meta.env.ARS_API_SERVER_URL;
export const __ARS_LEGACY_URL__ = import.meta.env.ARS_LEGACY_URL;
